import { DemoBadge } from "@/components/common/DemoBadge";
import { PageHeader } from "@/components/common/PageHeader";
import { MarketBoard } from "@/components/market/MarketBoard";
import { useHousehold } from "@/context/HouseholdContext";

export default function Market() {
  const { active } = useHousehold();
  return (
    <div className="space-y-8" data-testid="market-page">
      <PageHeader eyebrow="CASHMY Market" title="Market" text="La seconde main avec l'historique du bien en plus. Le paiement en ligne sécurisé arrivera avec un prestataire agréé." actions={active?.is_demo && <DemoBadge />} />
      {active && <MarketBoard key={active.id} hid={active.id} />}
    </div>
  );
}
